import styled from "styled-components";
import { Modal } from "react-bootstrap";
import { colors, types } from "../../../libs";

export const LimitModal = styled(Modal)`
  .modal-dialog {
    max-width: 520px;
  }
  .modal-content {
    background: transparent;
    border: 0;
  }
`;
export const ModalWrapper = styled.div`
  width: 100%;
  padding: 24px;
  background: ${colors.background.lightBlack};
  border-radius: 8px;
`;
export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 22px;
`;
export const ModalTitle = styled.div`
  ${types.body.secondaryTitle};
  color: ${colors.text.white};
  font-weight: bold;
`;
export const Subtitle = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  margin-top: 5px;
`;
export const CloseButton = styled.button`
  border: 0;
  background: transparent;
  color: ${colors.text.gray};
  display: flex;
  padding: 4px;
  &:hover {
    color: ${colors.text.white};
  }
`;
export const SwitchRow = styled.div`
  min-height: 64px;
  padding: 10px 14px;
  background: ${colors.background.formField};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
`;
export const SwitchCopy = styled.div`
  min-width: 0;
`;
export const SwitchTitle = styled.div`
  ${types.body.normal};
  color: ${colors.text.white};
`;
export const HelpText = styled.div`
  ${types.body.small};
  color: ${colors.text.disabled};
  margin-top: 5px;
`;
export const Field = styled.div`
  margin-top: 16px;
`;
export const ImmutableNote = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  margin-top: 18px;
  padding: 12px 14px;
  border-left: 2px solid ${colors.background.darkGreen};
  background: rgba(255, 255, 255, 0.025);
`;
export const Footer = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 24px;
`;
export const ButtonSlot = styled.div`
  flex: 1;
`;
